import { apiClient } from "../../base/ApiClient";


// Service for Funding
export const createService = async (formData) => {
    const response = await apiClient.post(`/client/services/`, formData);
    return response.data;
  };
  
export const getServices = async () => {
  const response = await apiClient.get(`/client/services/`);
  return response.data;
};

export const getServiceById = async (fundingId) => {
  const response = await apiClient.get(`/client/services/${fundingId}/`);
  return response.data;
};

export const updateService = async (fundingId, formData) => {
  const response = await apiClient.put(`/client/services/${fundingId}/`, formData);
  return response.data;
};

export const deleteService = async (fundingId) => {
  const response = await apiClient.delete(`/client/services/${fundingId}/`);
  return response.data;
};

// Service for Funders
export const createFunder = async (formData) => {
    const response = await apiClient.post(`/client/funders/`, formData);
    return response.data;
  };
  
export const getFunders = async (serviceID) => {
  const response = await apiClient.get(`/client/funders/?service_id=${serviceID}`);
  return response.data;
};

export const getFunderById = async (fundingId) => {
  const response = await apiClient.get(`/client/funders/${fundingId}/`);
  return response.data;
};

export const updateFunder = async (fundingId, formData) => {
  const response = await apiClient.put(`/client/funders/${fundingId}/`, formData);
  return response.data;
};

export const deleteFunder = async (fundingId) => {
  const response = await apiClient.delete(`/client/funders/${fundingId}/`);
  return response.data;
};

// Service for Funders
export const createRateCard = async (formData) => {
  const response = await apiClient.post(`/client/ratecards/`, formData);
  return response.data;
};
  
export const getRateCards = async () => {
  const response = await apiClient.get(`/client/ratecards/`);
  return response.data;
};

export const getRateCardById = async (fundingId) => {
  const response = await apiClient.get(`/client/ratecards/${fundingId}/`);
  return response.data;
};

export const updateRateCard = async (fundingId, formData) => {
  const response = await apiClient.put(`/client/ratecards/${fundingId}/`, formData);
  return response.data;
};

export const deleteRateCard = async (fundingId) => {
  const response = await apiClient.delete(`/client/ratecards/${fundingId}/`);
  return response.data;
};

// Service for Care Plan
export const createCarePlan = async (formData) => {
  const response = await apiClient.post(`/core/care-plans/`, formData);
  return response.data;
};
  
export const getCarePlans = async () => {
  const response = await apiClient.get(`/core/care-plans/`);
  return response.data;
};

export const getCarePlanById = async (planID) => {
  const response = await apiClient.get(`/core/care-plans/${planID}/`);
  return response.data;
};

export const updateCarePlan = async (planID, formData) => {
  const response = await apiClient.put(`/core/care-plans/${planID}/`, formData);
  return response.data;
};

export const deleteCarePlan = async (planID) => {
  const response = await apiClient.delete(`/core/care-plans/${planID}/`);
  return response.data;
};

export const getPaymentServices = async () => {
  const response = await apiClient.get(`/core/payment-services/`);
  return response.data;
};

// Service for Client Funding Profile
export const getClientPaymentServices = async (clientID) => {
  const response = await apiClient.get(`/client/${clientID}/care-plans/`);
  return response.data;
};

// Service for Employee Visit Checklist
export const getCheckList = async (clientID) => {
  const response = await apiClient.get(`/core/checklists/`);
  return response.data;
};